import { render, staticRenderFns } from "./LNotifications.vue?vue&type=template&id=d32f3040"
import script from "./LNotifications.vue?vue&type=script&lang=js"
export * from "./LNotifications.vue?vue&type=script&lang=js"
import style0 from "./LNotifications.vue?vue&type=style&index=0&id=d32f3040&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
